import EyeClosedIcon from '@/assets/svg/ui-elements/eye-closed.svg';
import EyeIcon from '@/assets/svg/ui-elements/eye-outline.svg';

import { PasswordRevealControl } from './auth-controls.styled';

type PasswordRevealToggleProps = {
  revealed: boolean;
  onToggle: (_revealed: boolean) => void;
  disabled?: boolean;
  revealLabel?: string;
  hideLabel?: string;
};

export const PasswordRevealToggle = ({
  revealed,
  onToggle,
  disabled = false,
  revealLabel = 'Show password',
  hideLabel = 'Hide password',
}: PasswordRevealToggleProps) => (
  <PasswordRevealControl
    type="button"
    color="tertiary"
    variant="ghost"
    size="sm"
    disabled={disabled}
    aria-label={revealed ? hideLabel : revealLabel}
    aria-pressed={revealed}
    data-auth-password-reveal
    onClick={() => onToggle(!revealed)}
  >
    {revealed ? <EyeIcon aria-hidden /> : <EyeClosedIcon aria-hidden />}
  </PasswordRevealControl>
);
